import React from 'react';

import './Container.css';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}

const Container: React.FC<ContainerProps> = ({ children, className = '' }) => {
  return <div className={`page-container ${className}`.trim()}>{children}</div>;
};

export default Container;
